<ng-container *ngIf="isDialogDisplayed">
  <kendo-window [title]="'dxsRetriever.title' | translate"
                [minWidth]="1100"
                [width]="1100"
                [minHeight]="670"
                (close)="cancel()"
                class="assign-properties-dialog top-left-counter-card k-window-content min-height-150 confirm-dialog app-confirm-dialog kendo-window-with-titlebar">
    <div class="search-content">
      <span class="retriever-margin dialogLabel uppercase title-wrapper">{{ 'dxsRetriever.searchText' | translate }}</span>
      <input id="dxsRetrieverInput" type="text" class="k-input k-textbox border-bottom-red" [(ngModel)]="searchTerm" (input)="search()" />
    </div>
    <div class="grid-host">
        <kendo-grid #kendoGrid class="retriever-grid"
                    (dataStateChange)="dataStateChanged($event)"
                    [pageable]="true"
                    [pageSize]="state.take"
                    [data]="gridDataResult"
                    [loading]="loading"
                    [skip]="state.skip"
                    [sortable]="true"
                    [sort]="state.sort"
                    [groupable]="false"
                    [filterable]="true"
                    [resizable]="true"
                    [selectable]="selectableSettings"
                    [filter]="state.filter"
                    (selectionChange)="onRowSelected($event)"
                    kendoGridSelectBy="Oid"
                    [columnMenu]="null"
                    [reorderable]="false">

          <kendo-grid-column field="NoJll" [width]="138" [title]="'dxsRetriever.searchGrid.noJLL' | translate"></kendo-grid-column>
          <kendo-grid-column field="Street1" [width]="150" [title]="'dxsRetriever.searchGrid.street' | translate"></kendo-grid-column>
          <kendo-grid-column field="StreetNo1" [width]="179" [title]="'dxsRetriever.searchGrid.streetNumber' | translate"></kendo-grid-column>
          <kendo-grid-column field="MunicipalManual" [width]="176" [title]="'dxsRetriever.searchGrid.municipality' | translate"></kendo-grid-column>
          <kendo-grid-column field="PostalCodeManual" [width]="176" [title]="'dxsRetriever.searchGrid.postCode' | translate"></kendo-grid-column>
          <kendo-grid-column field="CountryIDDescription" [width]="195" [title]="'dxsRetriever.searchGrid.country' | translate"></kendo-grid-column>
          <kendo-grid-column field="ProjectStdID" [width]="132" [title]="'dxsRetriever.searchGrid.puid' | translate"></kendo-grid-column>
          <kendo-grid-column field="NoNl" [width]="132" [title]="'dxsRetriever.searchGrid.noNL' | translate"></kendo-grid-column>
          <kendo-grid-column field="Oid" [width]="243" [title]="OID"></kendo-grid-column>

          <ng-template kendoPagerTemplate
                       let-totalPages="totalPages"
                       let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="pagerConfig.numericButtonsCount"></kendo-pager-numeric-buttons>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="pagerConfig.sizes"></kendo-pager-page-sizes>
            <div class="k-pager-info">{{pagerInfoMessage}}</div>

          </ng-template>

        </kendo-grid>
    </div>
    <div class="footer-content">
      <button class="k-button" (click)="cancel()">{{ 'dxsRetriever.buttonCancel' | translate }}</button>
    </div>
  </kendo-window>
  <div class="k-overlay overlay-confirm-dialog"></div>
</ng-container>
